import React from "react";

const Help = () => {
  return (
    <div className="container ">
      <h5 className="text-white text-center">
        <span className="border py-2 ps-3">
          How Can{" "}
          <span className="py-2 bg-white text-black px-1 pe-3">
            We Help You ?
          </span>
        </span>
      </h5>
      <div className="mt-5 ">
        <div className="d-flex justify-content-center align-items-center">
          <span className="fs-1">😊</span>
        </div>

        <div className="">
          <h6 className="text-white text-center">
            Contact us on sudoarun.js@gmail.com
          </h6>
        </div>
      </div>
    </div>
  );
};

export default Help;
